import { Action } from '../../types/Action';
import { DeleteModalProps } from '../../types/market-conquest/DeleteModalProps';
import { ExportModalProps } from '../../types/market-conquest/ExportModalProps';
import { NotesAndInsightsProps } from '../../types/market-conquest/NotesAndInsightsProps';
import { NotesCountMap } from '../../types/Note';

export const setIsCustomerModalOpen = (value: boolean): Action => ({
  type: MarketConquestModalActionsType.SET_CUSTOMER_MODAL_OPEN,
  payload: value,
});

export const setSelectedId = (value: string): Action => ({
  type: MarketConquestModalActionsType.SET_SELECTED_ID,
  payload: value,
});

export const setDeleteModalProps = (value: DeleteModalProps): Action => ({
  type: MarketConquestModalActionsType.SET_DELETE_MODAL_PROPS,
  payload: value,
});

export const setDeleteModalOpen = (value: boolean): Action => ({
  type: MarketConquestModalActionsType.SET_DELETE_MODAL_OPEN,
  payload: value,
});

export const setNotesModalOpen = (value: boolean): Action => ({
  type: MarketConquestModalActionsType.SET_NOTES_MODAL_OPEN,
  payload: value,
});

export const setNotesModalProps = (value: NotesAndInsightsProps): Action => ({
  type: MarketConquestModalActionsType.SET_NOTES_MODAL_PROPS,
  payload: value,
});

export const setUpdatedNotesCount = (value: NotesCountMap): Action => ({
  type: MarketConquestModalActionsType.SET_UPDATED_NOTES_COUNT,
  payload: value,
});

export const setNotesCountMap = (value: NotesCountMap[]): Action => ({
  type: MarketConquestModalActionsType.SET_NOTES_COUNT_MAP,
  payload: value,
});

export const setExportModalOpen = (value: boolean): Action => ({
  type: MarketConquestModalActionsType.SET_EXPORT_MODAL_OPEN,
  payload: value,
});

export const setExportModalProps = (value: ExportModalProps): Action => ({
  type: MarketConquestModalActionsType.SET_EXPORT_MODAL_PROPS,
  payload: value,
});

export const setCustomerModalProps = (value: string): Action => ({
  type: MarketConquestModalActionsType.SET_CUSTOMER_MODAL_PROPS,
  payload: value,
});

export const setIsPrivateIncentiveAvailable = (value: boolean): Action => ({
  type: MarketConquestModalActionsType.SET_PRIVATE_INCENTIVE_AVAILABLE,
  payload: value,
});

export enum MarketConquestModalActionsType {
  SET_CUSTOMER_MODAL_OPEN = 'Set customer modal open',
  SET_SELECTED_ID = 'Set selected id',
  SET_PRIVATE_INCENTIVE_AVAILABLE = 'Set Private Incentive Available',
  SET_DELETE_MODAL_OPEN = 'Set delete modal open',
  SET_DELETE_MODAL_PROPS = 'Set delete modal props',
  SET_NOTES_MODAL_OPEN = 'Set notes modal open',
  SET_NOTES_MODAL_PROPS = 'Set notes modal props',
  SET_UPDATED_NOTES_COUNT = 'Set updated notes count',
  SET_NOTES_COUNT_MAP = 'Set notes count map',
  SET_EXPORT_MODAL_OPEN = 'Set export modal open',
  SET_EXPORT_MODAL_PROPS = 'Set export modal props',
  SET_CUSTOMER_MODAL_PROPS = 'Set customer modal props',
}

export type MarketConquestModalActions = ReturnType<
  | typeof setIsCustomerModalOpen
  | typeof setSelectedId
  | typeof setDeleteModalProps
  | typeof setDeleteModalOpen
  | typeof setNotesModalOpen
  | typeof setNotesModalProps
  | typeof setUpdatedNotesCount
  | typeof setNotesCountMap
  | typeof setExportModalOpen
  | typeof setExportModalProps
  | typeof setCustomerModalProps
>;
